'use strict';

/**
 * Sync the list max-height to the rendered map image height.
 * @param {jQuery} $storeLocator - The root store locator container.
 * @returns {void}
 */
function syncStoreLocatorListHeight($storeLocator) {
    const $image = $storeLocator.find('.store-locator-map img.image-fluid');
    const $storeList = $storeLocator.find('.store-locator-store-list');
    const $navigation = $storeLocator.find('.store-locator-navigation');

    if (!$image.length || !$storeList.length || !$navigation.length) return;

    const imageHeight = $image[0].getBoundingClientRect().height;
    const navHeight = $navigation.outerHeight(true) || 0;
    const maxHeight = Math.max(imageHeight - navHeight, 0);

    $storeList.css('max-height', `${maxHeight}px`);
}

/**
 * Update the max-height for all store locator instances.
 * @returns {void}
 */
function updateStoreLocatorHeights() {
    $('.store-locator-container').each(function () {
        syncStoreLocatorListHeight($(this));
    });
}

/**
 * Initialize height sync for store locator components.
 * @returns {void}
 */
function initStoreLocatorHeightSync() {
    updateStoreLocatorHeights();

    $('.store-locator-map img.image-fluid').each(function () {
        const $img = $(this);
        if (this.complete) {
            syncStoreLocatorListHeight($img.closest('.store-locator-container'));
        } else {
            $img.on('load', function () {
                syncStoreLocatorListHeight($img.closest('.store-locator-container'));
            });
        }
    });

    $(window).on('resize.storeLocatorHeight', updateStoreLocatorHeights);
    $('body').on('click', '.tab-btn', () => setTimeout(updateStoreLocatorHeights, 0));
}

$(document).ready(function () {
    initStoreLocatorHeightSync();

    $('body').on('click', '.tab-btn', function () {
        const $btn = $(this);
        const $storeLocator = $btn.closest('.store-locator-container');
        const $navigationContainer = $btn.closest('.store-locator-navigation');
        const tabId = $btn.data('tab-button-id');

        const $mapSpots = $storeLocator.find('.store-locator-map_spot');
        const $currentMapSpots = $mapSpots.filter(`.${tabId}`);

        $storeLocator.find('.store-locator-map_spots-overlay').trigger('click');

        $storeLocator.find('.store-locator-store').removeClass('active');

        $mapSpots.addClass('d-none');
        $currentMapSpots.removeClass('d-none');

        $navigationContainer.find('.tab-btn').removeClass('active');
        $btn.addClass('active').blur();
        $storeLocator.find('[data-tab-id]').removeClass('active');
        $storeLocator.find(`[data-tab-id="${tabId}"]`).addClass('active');
    });

    $('body').on('click', '.store-locator-store', function () {
        const $storeCard = $(this);
        const $storeLocator = $storeCard.closest('.store-locator-container');
        const storeID = $storeCard.data('id');
        const $spot = $storeLocator.find(`.store-locator-map_spot-btn[data-id="${storeID}"]`);

        if (!$spot.length) return;

        $storeLocator.find('.store-locator-map_spots-overlay').trigger({ type: 'click', isSync: true });

        $storeLocator.find('.store-locator-store.active').removeClass('active');
        $storeCard.addClass('active');

        $spot.trigger({ type: 'click', isSync: true });
    });

    $('body').on('click', '.store-locator-map_spot-btn', function (e) {
        if (e.isSync) return;

        const $btn = $(this);
        const storeID = $btn.data('id');
        const $storeLocator = $btn.closest('.store-locator-container');
        const $card = $storeLocator.find(`.store-locator-store[data-id="${storeID}"]`);

        if (!$card.length) return;

        const $container = $card.parent();
        const cardEl = $card[0];
        const containerEl = $container[0];

        $storeLocator.find('.store-locator-store.active').removeClass('active');
        $card.addClass('active');

        const targetScrollPos = cardEl.offsetTop - containerEl.offsetTop;
        containerEl.scrollTo({
            top: targetScrollPos,
            behavior: 'smooth'
        });
    });
});
